import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import {
  uploadProfilePhotoMedia,
  upsertProfile,
} from "../../../../redux/slices/artistProfileSlice";
import classes from "./preferences.module.css";
import {
  fetchArtistByUsername,
  uploadPhotoMediaService,
} from "../../../../services";
import Cookies from "js-cookie";
import { toast, ToastContainer } from "react-toastify";
import { getYoutubeVideoId, notifySuccess } from "../../../../utils";
import { allCities } from "../../../../components/Onboarding/onboardingUtils";

const Preferences = ({ userData }) => {
  const dispatch = useDispatch();
  const [photoPreview, setPhotoPreview] = useState(null);

  // Initial profile state with user data
  const [profile, setProfile] = useState({
    things_i_enjoy: userData?.things_i_enjoy || [],
    photos: userData?.photos || [],
    videos: userData?.videos || [],
    categories: userData?.categories || [],
    where_do_love_performing: userData?.where_do_love_performing || [],
    available_locations: userData?.available_locations || [],
    // Non-editable fields
  });

  // Update profile state when userData changes (important for redux updates)
  useEffect(() => {
    if (userData) {
      setProfile({
        things_i_enjoy: userData.things_i_enjoy || [],
        photos: userData.photos || [],
        videos: userData.videos || [],
        categories: userData.categories || [],
        where_do_love_performing: userData.where_do_love_performing || [],
        available_locations: userData.available_locations || [],
      });
    }
  }, [userData]);

  const [editingCategory, setEditingCategory] = useState(null);
  const [photoUpload, setPhotoUpload] = useState(null);
  const [videoUrl, setVideoUrl] = useState("");
  const [errors, setErrors] = useState({});
  const [showPhotoUploader, setShowPhotoUploader] = useState(false);
  const [isPhotoUploading, setIsPhotoUploading] = useState(false);

  // Category options with genres
  const categoryOptions = [
    {
      name: "singer",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "bollywood",
        "pop",
        "western",
        "bhajan",
        "sufi",
        "jazz",
        "hip_hop",
        "rap",
        "ghazal",
        "punjabi",
        "classical",
        "folk",
        "rock",
        "devotional",
        "qawwali",
        "tamil",
        "telugu",
        "garba",
      ],
    },
    {
      name: "musician",
      image_url:
        "https://creartys.com/files/covers/Digital-Magician-Creartys--8--Portada-cropped-400x450.jpg",
      genres: [
        "bollywood",
        "pop",
        "western",
        "bhajan",
        "sufi",
        "jazz",
        "hip_hop",
        "rap",
        "ghazal",
        "punjabi",
        "classical",
        "folk",
        "rock",
        "devotional",
        "qawwali",
        "tamil",
        "telugu",
        "garba",
      ],
    },
    {
      name: "dancer",
      image_url:
        "https://img.freepik.com/free-photo/full-shot-ballerina-performance_23-2148871950.jpg",
      genres: [
        "bollywood",
        "folk",
        "hip_hop",
        "salsa",
        "wedding",
        "belly_dancer",
        "freestyle",
        "garba",
        "kathak",
        "classical",
        "bharatnatyam",
        "choreographer",
      ],
    },
    {
      name: "comedian",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: ["standup", "mimicry_artist", "comedy_group", "indie"],
    },
    {
      name: "magician",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "illusionist",
        "card_magician",
        "street_magician",
        "psychological",
        "table_magician",
      ],
    },
    {
      name: "music_band",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "bollywood",
        "pop",
        "western",
        "bhajan",
        "sufi",
        "jazz",
        "hip_hop",
        "rap",
        "ghazal",
        "punjabi",
        "classical",
        "folk",
        "rock",
        "devotional",
        "qawwali",
        "tamil",
        "telugu",
        "garba",
      ],
    },
    {
      name: "dance_group",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "bollywood",
        "folk",
        "hip_hop",
        "salsa",
        "wedding",
        "belly_dancer",
        "freestyle",
        "garba",
        "kathak",
        "classical",
        "bharatnatyam",
        "choreographer",
      ],
    },
    {
      name: "dj",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "techno",
        "dubstep",
        "edm",
        "bollywood_dj",
        "rock",
        "punjabi",
        "indie",
        "tamil",
        "telugu",
        "kannada",
        "malayalam",
      ],
    },
    {
      name: "rapper",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: ["rapper"],
    },
    {
      name: "beat_boxer",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: ["beat_boxer"],
    },
    {
      name: "video_editor",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "film",
        "documentary",
        "music_video",
        "commercial_advertisement",
        "corporate",
        "wedding",
        "vlogging",
        "social_media",
        "sports",
        "gaming_esports",
        "motion_graphics",
        "animation",
      ],
    },
    {
      name: "speaker",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: ["tedx", "motivational", "business", "indie"],
    },
    {
      name: "photography",
      image_url:
        "https://www.digitalmusicnews.com/wp-content/uploads/2017/10/musician_guitar.jpg",
      genres: [
        "portrait",
        "wedding",
        "fashion_photographer",
        "landscape",
        "wildlife",
        "sports",
        "product",
        "food",
        "street",
        "documentary",
      ],
    },
  ];

  // Common preference options
  const preferenceOptions = {
    things_i_enjoy: [
      "🎤 Vocal & Singing",
      "💃 Expressive Dance",
      "🎭 Theatrical Performance",
      "🎨 Visual Arts & Painting",
      "🎶 Instrumental & Music",
      "🪄 Magic & Illusions",
      "🤹 Acrobatics & Stunts",
      "📷 Photography & Cinematics",
    ],
    where_do_love_performing: [
      "🎭 Theaters & Stage Shows",
      "🎤 Concerts & Live Music Events",
      "🏟️ Festivals & Open-Air Venues",
      "🎥 Online & Social Media",
      "🏛️ Art Galleries & Exhibitions",
      "🎪 Street & Public Spaces",
    ],
    available_locations: allCities,
  };

  // Handle basic preference selection
  const handleSelect = (category, option) => {
    const updatedProfile = { ...profile };

    // Toggle selection
    if (updatedProfile[category].includes(option)) {
      updatedProfile[category] = updatedProfile[category].filter(
        (item) => item !== option
      );
    } else {
      updatedProfile[category] = [...updatedProfile[category], option];
    }

    setProfile(updatedProfile);
  };

  // Handle photo upload
  const handlePhotoUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setPhotoUpload(file);
      const fileUrl = URL.createObjectURL(file);
      setPhotoPreview(fileUrl);
    }
  };

  // Add uploaded photo to profile
  const addPhoto = async () => {
    if (photoUpload) {
      setIsPhotoUploading(true);
      const formData = new FormData();
      formData.append("media", photoUpload);
      const response = await fetch(uploadPhotoMediaService, {
        method: "POST",
        body: formData,
        headers: {
          authorization: `Bearer ${Cookies.get("accessToken")}`,
        },
      });
      const responseBody = await response.json();

      setProfile({
        ...profile,
        photos: [
          ...profile.photos,
          { mediaLink: responseBody?.file?.data?.mediaLink },
        ],
      });
      setIsPhotoUploading(false);
      setPhotoUpload(null);
      setPhotoPreview(null);
    }
  };

  // Remove photo from profile
  const removePhoto = (index) => {
    const updatedPhotos = [...profile.photos];
    updatedPhotos.splice(index, 1);
    setProfile({
      ...profile,
      photos: updatedPhotos,
    });
  };

  // YouTube URL validation
  const isValidYoutubeUrl = (url) => {
    const regExp = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.?be)\/.+$/;
    return regExp.test(url);
  };

  // Add YouTube video URL
  const addVideoUrl = () => {
    if (isValidYoutubeUrl(videoUrl)) {
      const videoUrlObj = {
        mediaLink: videoUrl,
      };
      setProfile({
        ...profile,
        videos: [...profile.videos, videoUrlObj],
      });
      setVideoUrl("");
      setErrors({ ...errors, videoUrl: "" });
    } else {
      setErrors({ ...errors, videoUrl: "Please enter a valid YouTube URL" });
    }
  };

  // Remove video
  const removeVideo = (index) => {
    const updatedVideos = [...profile.videos];
    updatedVideos.splice(index, 1);
    setProfile({
      ...profile,
      videos: updatedVideos,
    });
  };

  // Handle category selection (with 3 category limit)
  const handleCategorySelect = (categoryName) => {
    // Check if already selected (then remove it)
    const existingCategoryIndex = profile.categories.findIndex(
      (cat) => cat.name === categoryName
    );

    if (existingCategoryIndex >= 0) {
      // Remove the category
      const updatedCategories = [...profile.categories];
      updatedCategories.splice(existingCategoryIndex, 1);
      setProfile({
        ...profile,
        categories: updatedCategories,
      });
    } else if (profile.categories.length < 3) {
      // Add the category with empty genres
      setProfile({
        ...profile,
        categories: [...profile.categories, { name: categoryName, genre: [] }],
      });
    } else {
      setErrors({ ...errors, categories: "You can select up to 3 categories" });
    }
  };

  // Remove a category
  const handleDeleteCategory = (categoryIndex) => {
    const updatedCategories = [...profile.categories];
    updatedCategories.splice(categoryIndex, 1);
    setProfile({
      ...profile,
      categories: updatedCategories,
    });
  };

  // Handle genre selection for a category
  const handleGenreSelect = (categoryName, genreName) => {
    // Create deep copy of categories to ensure proper state updates
    const updatedCategories = JSON.parse(JSON.stringify(profile.categories));
    const categoryIndex = updatedCategories.findIndex(
      (cat) => cat.name === categoryName
    );

    if (categoryIndex >= 0) {
      const category = updatedCategories[categoryIndex];

      // Ensure genre is an array
      if (!Array.isArray(category.genre)) {
        category.genre = [];
      }

      // Toggle the genre
      if (category.genre.includes(genreName)) {
        category.genre = category.genre.filter((g) => g !== genreName);
      } else {
        category.genre = [...category.genre, genreName];
      }

      // Update the state with the new categories array
      setProfile({
        ...profile,
        categories: updatedCategories,
      });
    }
  };

  // Save all profile changes
  const handleSaveAll = async () => {
    try {
      // Create a copy of the profile data to save
      const profileToSave = {
        things_i_enjoy: profile.things_i_enjoy,
        photos: profile.photos,
        videos: profile.videos,
        categories: profile.categories,
        where_do_love_performing: profile.where_do_love_performing,
        available_locations: profile.available_locations,
      };

      // Dispatch the action to update the profile
      const result = await dispatch(upsertProfile(profileToSave)).unwrap();

      // Show success message
      notifySuccess("Profile updated successfully");

      // Optional: Refresh user data to ensure UI is in sync with server
      // You might need to implement this function if not already available
      // await refreshUserData();
    } catch (error) {
      console.error("Error saving profile:", error);
      toast.error("Failed to save profile. Please try again.");
    }
  };

  // Helper function to get YouTube ID from URL

  // Helper function to get genres for a category
  const getCategoryGenres = (categoryName) => {
    const category = categoryOptions.find((cat) => cat.name === categoryName);
    return category ? category.genres : [];
  };

  // Helper function to check if a genre is selected for a category
  const isCategoryGenreSelected = (categoryName, genreName) => {
    const category = profile.categories.find(
      (cat) => cat.name === categoryName
    );
    // Ensure genre is an array before checking includes
    return (
      category &&
      Array.isArray(category.genre) &&
      category.genre.includes(genreName)
    );
  };

  // Debug function to check category and genre structure
  const debugCategoryStructure = (categoryName) => {
    const category = profile.categories.find(
      (cat) => cat.name === categoryName
    );
    console.log("Category structure:", category);
    return category;
  };

  const formatCategoryName = (name) => {
    if (!name) return "";
    const formatted = name.replace(/_/g, " ");
    return formatted.charAt(0).toUpperCase() + formatted.slice(1);
  };

  return (
    <div className={classes.container}>
      <ToastContainer />
      <div className={classes.header}>
        <h1 className={classes.title}>MY PREFERENCES</h1>
      </div>

      {/* Two-column layout for profile information */}
      <div className={classes.twoColumnLayout}>
        {/* Left column */}
        <div className={classes.column}>
          {/* Non-editable profile info */}

          {/* Things I Enjoy Section */}
          <div className={classes.section}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>Things I Enjoy</h2>
              <button
                onClick={() => setEditingCategory("things_i_enjoy")}
                className={classes.editButton}
              >
                Edit
              </button>
            </div>
            <div className={classes.tagsContainer}>
              {profile.things_i_enjoy.map((tag) => (
                <div key={tag} className={classes.tag}>
                  {tag}
                </div>
              ))}
              {profile.things_i_enjoy.length === 0 && (
                <div className={classes.emptyState}>Add things you enjoy</div>
              )}
            </div>
          </div>

          {/* Categories Section */}
          <div className={classes.categoriesSection}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>Categories (Max 3)</h2>
              {profile.categories.length < 3 && (
                <button
                  className={classes.editButton}
                  onClick={() => setEditingCategory("categories")}
                >
                  Add
                </button>
              )}
            </div>
            {errors.categories && (
              <p className={classes.error}>{errors.categories}</p>
            )}
            <div className={classes.categoriesContainer}>
              {profile.categories.map((category, index) => (
                <div key={index} className={classes.categoryBox}>
                  <div className={classes.categoryHeader}>
                    <h3 className={classes.categoryName}>
                      {formatCategoryName(category.name)}
                    </h3>
                    <button
                      className={classes.deleteButton}
                      onClick={() => handleDeleteCategory(index)}
                    >
                      ×
                    </button>
                  </div>
                  <div className={classes.genreList}>
                    {Array.isArray(category.genre) &&
                    category.genre.length > 0 ? (
                      category.genre.map((genreName) => (
                        <div key={genreName} className={classes.genreTag}>
                          {genreName}
                        </div>
                      ))
                    ) : (
                      <div className={classes.emptyGenre}>
                        No genres selected
                      </div>
                    )}
                  </div>
                  <button
                    className={classes.editGenreButton}
                    onClick={() => {
                      // Debug category structure before opening modal
                      console.log("Opening genre editor for:", category.name);
                      debugCategoryStructure(category.name);
                      setEditingCategory(`category-${category.name}`);
                    }}
                  >
                    Edit Genres
                  </button>
                </div>
              ))}
              {profile.categories.length === 0 && (
                <div className={classes.emptyCategories}>
                  Add up to 3 categories to describe your artistic talents
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right column */}
        <div className={classes.column}>
          {/* Where I Love Performing Section */}
          <div className={classes.section}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>Where I Love Performing</h2>
              <button
                onClick={() => setEditingCategory("where_do_love_performing")}
                className={classes.editButton}
              >
                Edit
              </button>
            </div>
            <div className={classes.tagsContainer}>
              {profile.where_do_love_performing.map((tag) => (
                <div key={tag} className={classes.tag}>
                  {tag}
                </div>
              ))}
              {profile.where_do_love_performing.length === 0 && (
                <div className={classes.emptyState}>Add performance venues</div>
              )}
            </div>
          </div>

          {/* Available Locations Section */}
          <div className={classes.section}>
            <div className={classes.sectionHeader}>
              <h2 className={classes.sectionTitle}>Available Locations</h2>
              <button
                onClick={() => setEditingCategory("available_locations")}
                className={classes.editButton}
              >
                Edit
              </button>
            </div>
            <div className={classes.tagsContainer}>
              {profile.available_locations.map((tag) => (
                <div key={tag} className={classes.tag}>
                  {tag}
                </div>
              ))}
              {profile.available_locations.length === 0 && (
                <div className={classes.emptyState}>
                  Add locations where you're available
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* Photos Section - Full width */}
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <h2 className={classes.sectionTitle}>Photos</h2>
          <button
            onClick={() => setShowPhotoUploader(!showPhotoUploader)}
            className={classes.editButton}
          >
            {showPhotoUploader ? "Hide Uploader" : "Add Photos"}
          </button>
        </div>

        {/* Photo uploader */}
        {showPhotoUploader && (
          <div className={classes.uploaderSection}>
            <input
              type="file"
              accept="image/*"
              onChange={handlePhotoUpload}
              id="photo-upload"
              style={{ display: "none" }}
            />
            <label htmlFor="photo-upload" className={classes.uploadButton}>
              Select Image
            </label>
            {photoPreview && (
              <div className={classes.previewSection}>
                <img
                  src={photoPreview}
                  alt="Preview"
                  className={classes.photoPreview}
                />
                <div className={classes.previewActions}>
                  {!isPhotoUploading ? (
                    <button className={classes.addButton} onClick={addPhoto}>
                      Add to Gallery
                    </button>
                  ) : (
                    "Uploading..."
                  )}
                  <button
                    className={classes.cancelButton}
                    onClick={() => setPhotoPreview(null)}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* Photo gallery */}
        <div className={classes.photoGrid}>
          {profile?.photos?.map((photo, index) => (
            <div key={index} className={classes.photoContainer}>
              <img
                src={photo?.mediaLink}
                alt={`Upload ${index + 1}`}
                className={classes.photo}
              />
              <button
                className={classes.removeButton}
                onClick={() => removePhoto(index)}
              >
                ×
              </button>
            </div>
          ))}
          {profile?.photos?.length === 0 && (
            <div className={classes.emptyPhotos}>
              Add photos to showcase your talent
            </div>
          )}
        </div>
      </div>

      {/* Videos Section - Full width */}
      <div className={classes.section}>
        <div className={classes.sectionHeader}>
          <h2 className={classes.sectionTitle}>Videos (YouTube URLs)</h2>
        </div>

        {/* Video input */}
        <div className={classes.videoInputRow}>
          <input
            type="text"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            placeholder="Enter YouTube URL"
            className={classes.videoInput}
          />
          <button className={classes.addButton} onClick={addVideoUrl}>
            Add Video
          </button>
        </div>

        {errors.videoUrl && <p className={classes.error}>{errors.videoUrl}</p>}

        {/* Video gallery */}
        <div className={classes.videoGrid}>
          {profile?.videos?.map((video, index) => (
            <div key={index} className={classes.videoContainer}>
              <iframe
                src={`https://www.youtube.com/embed/${getYoutubeVideoId(
                  video?.mediaLink
                )}`}
                title={`Video ${index + 1}`}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className={classes.videoIframe}
              ></iframe>
              <button
                className={classes.removeButton}
                onClick={() => removeVideo(index)}
              >
                ×
              </button>
            </div>
          ))}
          {profile.videos.length === 0 && (
            <div className={classes.emptyVideos}>
              Add YouTube videos to showcase your performances
            </div>
          )}
        </div>
      </div>

      {/* Save All Button */}
      <div className={classes.saveAllContainer}>
        <button className={classes.saveAllButton} onClick={handleSaveAll}>
          Save All Changes
        </button>
      </div>

      {/* Modal for editing regular preferences */}
      {editingCategory &&
        !editingCategory.startsWith("category-") &&
        editingCategory !== "categories" && (
          <div className={classes.modal}>
            <div className={classes.modalContent}>
              <div className={classes.modalHeader}>
                <h2>{getCategoryTitle(editingCategory)}</h2>
                <button
                  className={classes.closeButton}
                  onClick={() => setEditingCategory(null)}
                >
                  ×
                </button>
              </div>
              <div className={classes.modalBody}>
                <div className={classes.optionsContainer}>
                  {preferenceOptions[editingCategory]?.map((option) => (
                    <div
                      key={option}
                      className={`${classes.optionTab} ${
                        profile[editingCategory].includes(option)
                          ? classes.selected
                          : ""
                      }`}
                      onClick={() => handleSelect(editingCategory, option)}
                    >
                      {option}
                      {profile[editingCategory].includes(option) && (
                        <span className={classes.checkmark}>✓</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
              <div className={classes.modalFooter}>
                <button
                  className={classes.saveButton}
                  onClick={() => setEditingCategory(null)}
                >
                  Save
                </button>
              </div>
            </div>
          </div>
        )}

      {/* Modal for selecting categories */}
      {editingCategory === "categories" && (
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <div className={classes.modalHeader}>
              <h2>Select Categories (Max 3)</h2>
              <button
                className={classes.closeButton}
                onClick={() => setEditingCategory(null)}
              >
                ×
              </button>
            </div>
            <div className={classes.modalBody}>
              <div className={classes.optionsGrid}>
                {categoryOptions.map((category) => (
                  <div
                    key={category.name}
                    className={`${classes.optionCard} ${
                      profile?.categories?.some((c) => c.name === category.name)
                        ? classes.selectedCard
                        : ""
                    }`}
                    onClick={() => handleCategorySelect(category.name)}
                  >
                    <div className={classes.optionCardContent}>
                      <div className={classes.optionCardTitle}>
                        {formatCategoryName(category?.name)}
                      </div>
                      <div className={classes.optionCardGenres}>
                        {category?.genres?.slice(0, 3).join(", ")}
                        {category?.genres?.length > 3 ? "..." : ""}
                      </div>
                    </div>
                    {profile.categories.some(
                      (c) => c?.name === category?.name
                    ) && <span className={classes.cardCheckmark}>✓</span>}
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.modalFooter}>
              <button
                className={classes.saveButton}
                onClick={() => setEditingCategory(null)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal for editing genres for a specific category */}
      {editingCategory && editingCategory.startsWith("category-") && (
        <div className={classes.modal}>
          <div className={classes.modalContent}>
            <div className={classes.modalHeader}>
              <h2>
                Select Genres for {editingCategory.replace("category-", "")}
              </h2>
              <button
                className={classes.closeButton}
                onClick={() => setEditingCategory(null)}
              >
                ×
              </button>
            </div>
            <div className={classes.modalBody}>
              <div className={classes.optionsGrid}>
                {getCategoryGenres(
                  editingCategory?.replace("category-", "")
                ).map((genre) => (
                  <div
                    key={genre}
                    className={`${classes.genreOption} ${
                      isCategoryGenreSelected(
                        editingCategory.replace("category-", ""),
                        genre
                      )
                        ? classes.selectedGenre
                        : ""
                    }`}
                    onClick={() =>
                      handleGenreSelect(
                        editingCategory.replace("category-", ""),
                        genre
                      )
                    }
                  >
                    {genre}
                    {isCategoryGenreSelected(
                      editingCategory.replace("category-", ""),
                      genre
                    ) && <span className={classes.genreCheckmark}>✓</span>}
                  </div>
                ))}
              </div>
            </div>
            <div className={classes.modalFooter}>
              <button
                className={classes.saveButton}
                onClick={() => setEditingCategory(null)}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );

  // Helper function to get category title
  function getCategoryTitle(category) {
    const titles = {
      things_i_enjoy: "Things I Enjoy",
      where_do_love_performing: "Where I Love Performing",
      available_locations: "Available Locations",
    };
    return titles[category] || category;
  }
};

export default Preferences;
